<template>
  <div id="choicePeopleComponent">
    <hr-dialog title="选人组件" :allowFull="false" width="50%" :visible.sync="visible">
      <template slot="body">
        <div class="main" style="display:flex">
          <div class="left" style="width:50%">
            <el-radio-group
              v-if="!this.option.deptId"
              v-model="tabObject"
              style="margin-bottom: 30px;"
            >
              <el-radio-button label="dept">部门</el-radio-button>
             
            </el-radio-group>

            <div v-show="tabObject == 'dept'" class="dept">
              <div class="navigation_bar">
                <div
                  @click="navBarClick(item, index)"
                  v-for="(item, index) in navigationBarList"
                  :key="index"
                  :style="
                    index == navigationBarList.length - 1 ? 'color:#303133' : 'color:#909399 '
                  "
                >
                  {{ item.title }}<span v-if="index < navigationBarList.length - 1"> > </span>
                </div>
              </div>
              <div
                v-if="
                  choiceModel != 'singlePeople' &&
                    choiceModel != 'people' &&
                    choiceModel != 'singleDept' &&
                    choiceModel != 'dept'
                "
              >
                <div style="margin: 16px 0;"></div>
                <el-checkbox v-model="currentObjectDept.isAllCheck" @change="handleCheckAllChange"
                  >全选</el-checkbox
                >
              </div>
              <div style="margin: 16px 0;"></div>
              <div
                v-for="(item, index) in nowDeptList"
                :key="index"
                class="choice_item"
                style="display:flex;justify-content: space-between;margin-bottom:16px"
              >
                <div>
                  <el-checkbox
                    v-if="choiceModel != 'singlePeople' && choiceModel != 'people'"
                    v-model="item.isChecked"
                    @change="
                      () => {
                        clickCheckBox(item, selectDeptList);
                      }
                    "
                    :indeterminate="item.halfCheck"
                  >
                    <!-- showHalf(item.checkSum,item) -->
                  </el-checkbox>
                  <span>
                    <span>
                      {{ item.title }}
                    </span>
                    <span
                      v-if="
                        choiceModel !== 'dept' &&
                          choiceModel !== 'singleDept' &&
                          choiceModel !== 'unlimitDept'
                      "
                    >
                      <span v-if="item.checkSum > 0" style="color:#409EFF"
                        >({{ item.checkSum + '/' + item.userSum }})</span
                      >
                      <span v-else style="color:#c0c4cc">({{ item.userSum }})</span>
                    </span>
                  </span>
                </div>
                <div style="display: flex;align-items: center;cursor:pointer;">
                  <div style="height: 14px;border-left: 1px solid #DCDFE6;width:10px"></div>
                  <div
                    @click.stop="goSubordinate(item)"
                    :style="item.isChecked ? 'color:#C0C4CC;' : ''"
                    class="subordinateLable"
                  >
                    下级
                  </div>
                </div>
              </div>
              <!-- 人员列表 -->
              <div
                v-if="
                  currentObjectDept['peopleListInfo'] &&
                    choiceModel != 'dept' &&
                      choiceModel != 'singleDept' &&
                      choiceModel != 'unlimitDept'
                "
              >
                <div
                  v-for="(item, index) in currentObjectDept.peopleListInfo.peopleList"
                  :key="index"
                  class="choice_item"
                  style="display:flex;justify-content: space-between;margin-bottom:16px"
                >
                  <div>
                    <el-checkbox
                      v-model="item.isChecked"
                      @change="
                        () => {
                          clickPeopleCheckBox(
                            item,
                            selectPeopleList,
                            currentObjectDept.peopleListInfo
                          );
                        }
                      "
                    ></el-checkbox>
                    <span>
                      <span>{{ item.realName }}</span>
                      <span style="color: #c0c4cc;margin-left:8px" v-if="item[additionalFiled]"
                        >({{ item[additionalFiled] }})</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="tabObject == 'team'" class="team">
              <div class="navigation_bar">
                <div
                  @click="groupNavBarClick(item, index)"
                  v-for="(item, index) in groupNavigationBarList"
                  :key="index"
                  :style="
                    index == groupNavigationBarList.length - 1 ? 'color:#303133' : 'color:#909399 '
                  "
                >
                  {{ item.title || item.name
                  }}<span v-if="index < groupNavigationBarList.length - 1"> > </span>
                </div>
              </div>
              <div v-if="choiceModel != 'singlePeople' && choiceModel != 'people'">
                <div style="margin: 16px 0;"></div>
                <el-checkbox
                  v-model="currentObjectGroup.isAllCheck"
                  @change="handleGroupCheckAllChange"
                  >全选</el-checkbox
                >
              </div>
              <div style="margin: 16px 0;"></div>
              <div v-show="groupShow">
                <div
                  v-for="(item, index) in groupList"
                  :key="index"
                  class="choice_item"
                  style="display:flex;justify-content: space-between;margin-bottom:16px"
                >
                  <div>
                    <el-checkbox
                      v-model="item.isChecked"
                      :indeterminate="item.halfCheck"
                      v-if="choiceModel != 'singlePeople' && choiceModel != 'people'"
                      @change="
                        () => {
                          clickGroupCheckBox(item, selectGroupList);
                        }
                      "
                    ></el-checkbox>
                    <span>
                      <span>{{ item.name }}</span>
                      <span style="margin-left:8px">
                        <span v-if="item.checkSum > 0" style="color:#409EFF"
                          >({{ item.checkSum + '/' + item.userSum }})</span
                        >
                        <span v-else>({{ item.userSum }})</span>
                      </span>
                    </span>
                  </div>
                  <div style="display: flex;align-items: center;cursor:pointer;">
                    <div style="height: 14px;border-left: 1px solid #DCDFE6;width:10px"></div>
                    <div
                      @click.stop="goGroupSubordinate(item)"
                      :style="item.isChecked ? 'color:#C0C4CC;' : ''"
                      class="subordinateLable"
                    >
                      下级
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="currentObjectGroup.peopleListInfo">
                <div
                  v-for="(item, index) in currentObjectGroup.peopleListInfo.peopleList"
                  :key="index"
                  class="choice_item"
                  style="display:flex;justify-content: space-between;margin-bottom:16px"
                >
                  <div>
                    <el-checkbox
                      v-model="item.isChecked"
                      @change="
                        () => {
                          clickGroupPeopleCheckBox(
                            item,
                            selectPeopleList,
                            currentObjectGroup.peopleListInfo
                          );
                        }
                      "
                    ></el-checkbox>
                    <span>{{ item.realName }}</span>
                    <span style="color: #909399;margin-left:8px" v-if="item[additionalFiled]"
                      >({{ item[additionalFiled] }})</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="right" style="width:50%;border-left: 1px solid #DCDFE6;">
            <div
              class="searchArea"
              v-if="
                choiceModel != 'dept' && choiceModel != 'singleDept' && choiceModel != 'unlimitDept'
              "
            >
              <el-form :model="searchForm" ref="searchFormRef">
                <el-row style="margin-left:0" :gutter="24">
                  <el-col :span="18" style="padding-right:0">
                    <el-form-item prop="projectId">
                      <el-popover
                        placement="bottom"
                        :close-on-click-modal="true"
                        ref="popoverRef"
                        trigger="manual"
                        v-model="searchResultVisible"
                      >
                        <el-input
                          slot="reference"
                          clearable
                          v-model="searchFrom.value"
                          :placeholder="
                            this.option.searchPlaceholder
                              ? this.option.searchPlaceholder
                              : '姓名、电话'
                          "
                        ></el-input>
                        <div class="searchResult">
                          <div
                            v-if="searchResultPeopleList.length <= 0"
                            style="text-align: center;"
                          >
                            <span style="color:#c0c4cc">未匹配到结果</span>
                          </div>
                          <div
                            v-else
                            v-for="(item, index) in searchResultPeopleList"
                            :key="item"
                            class="searchChoice_item"
                            style="display:flex;margin-bottom:16px"
                          >
                            <div style="display: flex;align-items: center;">
                              <div>
                                <el-checkbox
                                  v-model="item.isChecked"
                                  @change="
                                    () => {
                                      clickSearchPeopleCheckBox(item, selectPeopleList);
                                    }
                                  "
                                ></el-checkbox>
                              </div>
                            </div>
                            <div>
                              <div>
                                <span v-html="item.nameCopy"></span>
                                <span
                                  style="color:#c0c4cc;margin-left:8px"
                                  v-if="item.searchCopy"
                                  v-html="item.searchCopy"
                                ></span>
                              </div>
                              <div>
                                <span
                                  style="color:#909399;font-size: 12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                                >
                                  {{ item.deptName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-popover>
                      <!-- <el-input v-model="searchFrom.value" placeholder="姓名、电话"></el-input> -->
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <div style="text-align: right;">
                      <el-button
                        type="primary"
                        icon="el-icon-search"
                        @click.stop="searchRecord"
                        size="small"
                      >
                        搜索
                      </el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="selectInfo">
              <div v-for="(item, index) in selectPeopleList" :key="index" class="selectItem">
                <el-tag
                  type="info"
                  disable-transitions
                  :key="item"
                  closable
                  @close="selectPeopleListDelete(item, selectPeopleList)"
                >
                  {{ item.realName }}</el-tag
                >
              </div>
              <div v-for="(item, index) in selectDeptList" :key="index" class="selectItem">
                <el-tag
                  type="info"
                  disable-transitions
                  :key="item"
                  closable
                  @close="selectDeptListDelete(item, selectDeptList)"
                >
                  {{ item.title }} <span>({{ item.userSum }})</span></el-tag
                >
              </div>
              <div v-for="(item, index) in selectGroupList" :key="index" class="selectItem">
                <el-tag
                  type="info"
                  disable-transitions
                  :key="item"
                  closable
                  @close="selectGroupListDelete(item, selectGroupList)"
                >
                  {{ item.name }}<span>({{ item.userSum }})</span></el-tag
                >
              </div>
            </div>
            <div class="btnArea" style="text-align:right;">
              <el-button
                size="small"
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="submitSelect"
                style="margin-right: 16px"
              >
                <span>确定</span>
                <!-- 单选模式 -->
                <span
                  style="margin-left:8px;line-height: 14px;"
                  v-if="option.model == 'singlePeople'"
                  >({{ checkedPeopleNum }}/1)</span
                >
                <span style="margin-left:8px;line-height: 14px;" v-if="option.model == 'people'"
                  >({{ checkedPeopleNum }}/{{ option.limit }})</span
                >
                <span
                  style="margin-left:8px;line-height: 14px;"
                  v-if="option.model == 'unlimitPeople'"
                  >{{ checkedPeopleNum != 0 ? '(' + checkedPeopleNum + ')' : '' }}</span
                >
              </el-button>
              <el-button
                style="margin-left: 0px"
                @click="closeRecord"
                size="small"
                icon="el-icon-circle-close"
                >取 消</el-button
              >
            </div>
          </div>
        </div>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import {
  treeByProjectDeptId,
  getUserListByDepartmentId,
  getGroupList,
  getAssembleUser,
  getMenberUserList,
  treeByDeptId,
  deptUserList,
  getUserNameListByDeptId,
  getDeptUserListByDeptId
} from './index.js';

export default {
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    selectList: {
      type: Array,
      default() {
        return [];
      },
    }, //已选的集合
    option: {
      default: {
        projectId: '',
        variable: '',
        searchType: '',
        searchPlaceholder: '姓名、电话',
        deptId: '',
        model: 'singlePeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [
          {
            id: '1466297888857010178',
            realName: '鸿润',
          },
        ], //已选的集合
        prohibitList: [
          {
            id: '1401897922670817282',
          },
        ], //禁止选的集合
        limit: 2,
      },
    },
  },
  data() {
    return {
      checkedPeopleNum: 0,
      additionalFiled: '',
      submitList: [],

      groupList: [], //班组集合
      groupNavigationBarList: [], //班组导航栏集合
      searchResultPeopleList: [], //搜索人员结果
      groupShow: true, //班组显示（因为班组下面没有子班组所以采用简单的方式来控制页面效果）
      searchFrom: {
        value: '',
      }, //搜索条件对象
      tabObject: 'dept',
      searchResultVisible: false,
      isIndeterminate: true,
      nowDeptList: [], //当前展示的部门列表
      deptData: [], //最上级的部门列表,
      navigationBarList: [], //导航栏数据
      nowPeopleList: [], //当前人员选择
      currentObjectGroup: {
        peopleListInfo: {
          peopleList: [],
          parent: null,
        },
      }, //当前班组展示对象的数据（展示人员信息）
      currentObjectDept: {
        peopleListInfo: {
          peopleList: [],
          parent: null,
        },
      }, //当前展示对象的数据（展示人员信息）
      selectPeopleList: [], //已选择人员的集合
      selectDeptList: [], //已选部门集合
      selectGroupList: [], //已选班组集合
      okBtnLable: '(0/1)',
      wholeModel: '', //全局模式，判断是选人组件还是选部门组件
      choiceModel: '', //选择模式，细分模式
    };
  },
  created() {
    this.tackleModel();

    console.log('daying');
    this.getDeptTree();
  },
  watch: {
    visible() {
      this.$emit('update:visible', false);
    },
  },
  mounted() {
    this.calculatePeopleSum();
  },
  methods: {
    //删除班组下面的人员
    deletGroup(people) {
      this.groupList.forEach((item) => {
        if (item.peopleListInfo && item.peopleListInfo.peopleList) {
          item.peopleListInfo.peopleList.forEach((item2) => {
            if (item2.id == people.id) {
              item2.isChecked = false;
            }
          });
        }
      });
    },
    placeString() {
      return this.option.searchString ? '姓名' + '、' + this.option.searchString : '姓名、电话';
    },
    calculateModel() {
      if (
        this.option.model == 'people' ||
        this.option.model == 'singlePeople' ||
        this.option.model == 'unlimitPeople'
      ) {
        this.wholeModel = 'people';
      } else {
        this.wholeModel = 'dept';
      }
    },
    //父级向上遍历
    goFather(dept) {
      console.log('fuqing', dept.title);
      this.calculateSelectStatus(dept);
      this.easyCalculateSum(dept);
      if (dept.parent) {
        this.goFather(dept.parent);
      }
    },
    deptOperatePeopleStatus(data, id) {
      console.log(data.title);
      try {
        data.peopleListInfo.peopleList.forEach((item) => {
          if (item.id == id) {
            console.log('这个是正确的的', item.parent.title);
            item.isChecked = false;
            item.parent.checkSum--;
            this.goFather(item.parent);
          }
        });
      } catch {
        console.log('dd');
      }
      if (data.hasChildren) {
        data.children.forEach((item) => {
          this.deptOperatePeopleStatus(item, id);
        });
      }
    },
    selectPeopleListDelete(item, data) {
      console.log(item);
      this.removeItemFormData(item, data);
      //遍历部门把所有的人员状态变为未选
      this.deptOperatePeopleStatus(this.deptData, item.id);
      //遍历班组删除
      this.deletGroup(item);
      if (item.parent) {
        this.calculateSelectSum(item.parent, 'reduce');
      }
      this.removePeopleRemoveDept(item.parent);
      if (item.parent) {
        this.goUpCalculateSelectStatus(item.parent);
      }
      console.log('这是所有数据集合', this.deptData);
    },
    //删除人员时删除父级
    removePeopleRemoveDept(dept) {
      let indexNum = -1;
      this.selectDeptList.forEach((item, index) => {
        if (dept.id == item.id) {
          indexNum = index;
        }
      });
      if (indexNum >= 0) {
        this.selectDeptList.splice(indexNum, 1);
      }
    },
    goUpCalculateSelectStatus(dept) {
      this.calculateSelectStatus(dept);
      if (dept.parent) {
        this.goUpCalculateSelectStatus(dept.parent);
      }
    },
    selectDeptListDelete(item, data) {
      item.checkSum = 0;
      item.isChecked = false;
      item.halfCheck = false;
      this.setDeptStatus(item, false);
      this.removeItemFormData(item, data);
      this.calculateSelectDeptSum(item.parent, item.userSum, 'reduce');
      this.goUpCalculateSelectStatus(item);
    },
    selectGroupListDelete(item, data) {
      item.checkSum = 0;
      item.halfCheck = false;
      this.removeItemFormData(item, data);
    },
    calculatePeopleSum() {
      let sum = 0;
      if (this.choiceModel == 'unlimitPeople') {
        this.selectDeptList.forEach((item) => {
          sum += item.checkSum;
        });
        sum += this.selectPeopleList.length;

        this.selectGroupList.forEach((group) => {
          sum += group.checkSum;
        });
        if (sum > 0) {
          this.okBtnLable = '(' + sum + ')';
        } else {
          this.okBtnLable = '(0/1)';
        }
      }
      if (this.choiceModel == 'people') {
        this.selectDeptList.forEach((item) => {
          sum += item.checkSum;
        });
        sum += this.selectPeopleList.length;

        this.selectGroupList.forEach((group) => {
          sum += group.checkSum;
        });
        if (sum > 0) {
          this.okBtnLable = '(' + sum + '/' + this.option.limit + ')';
        } else {
          this.okBtnLable = '(' + 0 + '/' + this.option.limit + ')';
        }
      }
      if (this.choiceModel == 'singlePeople') {
        this.selectDeptList.forEach((item) => {
          sum += item.checkSum;
        });
        sum += this.selectPeopleList.length;

        this.selectGroupList.forEach((group) => {
          sum += group.checkSum;
        });
        if (sum > 0) {
          this.okBtnLable = '(' + sum + '/' + 1 + ')';
        } else {
          this.okBtnLable = '(0/1)';
        }
      }
      if (this.choiceModel == 'dept') {
        sum += this.selectDeptList.length;
        if (sum > 0) {
          this.okBtnLable = '(' + sum + '/' + this.option.limit + ')';
        } else {
          this.okBtnLable = '(' + 0 + '/' + this.option.limit + ')';
        }
      }
      if (this.choiceModel == 'unlimitDept') {
        sum += this.selectDeptList.length;
        if (sum > 0) {
          this.okBtnLable = '(' + sum + ')';
        } else {
          this.okBtnLable = '(0/1)';
        }
      }
      if (this.choiceModel == 'singleDept') {
        sum += this.selectDeptList.length;
        if (sum > 0) {
          this.okBtnLable = '(' + sum + '/' + 1 + ')';
        } else {
          this.okBtnLable = '(0/1)';
        }
      }
      this.checkedPeopleNum = sum;
    },
    closeRecord() {
      this.$emit('update:visible', false);
    },
    tackleModel() {
      this.option.projectId = this.option.projectId || '';
      this.option.model = this.option.model || 'singlePeople';
      this.option.limit = this.option.limit || 1;
      this.option.variable = this.option.variable || 3;
      this.option.searchType = this.option.searchType || 'phone';
      this.additionalFiled = this.option.searchType;
      if (this.option.model == 'unlimitPeople') {
        this.okBtnLable = '';
      } else {
        this.okBtnLable = '(0/' + this.option.limit + ')';
      }
      if (!(this.option.selectList && this.option.selectList.length > 0)) {
        this.option.selectList = [];
      } else {
        if (
          this.option.model == 'people' ||
          this.option.model == 'singlePeople' ||
          this.option.model == 'unlimitPeople'
        ) {
          this.selectPeopleList = this.option.selectList;
        } else {
          this.selectDeptList = this.option.selectList;
        }
      }
      if (!(this.option.prohibitList && this.option.prohibitList.length > 0)) {
        this.option.prohibitList = [];
      }
      this.choiceModel = this.option.model;
      this.calculateModel();
    },
    searchRecord() {
      document.body.addEventListener('click', () => {
        if (this.searchResultVisible) {
          this.searchResultVisible = false;
        }
      });
      getUserNameListByDeptId({
        // projectId: this.option.projectId,
        variable: this.option.variable,
        deptId: this.option.deptId || '',
        name: this.searchFrom.value,
      }).then((res) => {
        this.searchResultPeopleList = res.data;
        this.searchResultPeopleList.forEach((item) => {
          item.isChecked = false;
          this.$set(item, 'isCheck', false);
          this.selectPeopleList.forEach((item1) => {
            if (item1.id == item.id) {
              console.log('有相同的');
              item.isChecked = true;
            }
          });
          this.searchLightHeight(item);
          this.$forceUpdate();
        });
        console.log('搜索结果', this.searchResultPeopleList);
      });

      this.searchResultVisible = !this.searchResultVisible;
      try {
        let dom = document.getElementsByClassName('el-popover el-popper')[1];
        dom.style.width = '22%';
      } catch {
        return;
      }
    },
    //根据已选的人员来判断搜索的人员是否为已选中的状态
    searchResultIsCheckedSign(people) {
      this.selectPeopleList.forEach((item) => {
        if (item.id == people.id) {
          people = item;
          console.log('dadds', people);
        }
      });
      return people;
    },
    searchLightHeight(item) {
      let reg = new RegExp(this.searchFrom.value, 'g');
      let replaceValue = '<span class="search-color">' + this.searchFrom.value + '</span>';

      item.nameCopy = item.realName.replace(reg, replaceValue);
      item.searchCopy = item[this.additionalFiled]
        ? '(' + item[this.additionalFiled].replace(reg, replaceValue) + ')'
        : '';
    },
    //导航栏点击
    navBarClick(item, index) {
      item.isAllCheck = false;
      if (this.navigationBarList.length == 1) {
        return;
      }

      console.log('点击盗汗蓝', item);

      this.nowDeptList = item.children;
      this.currentObjectDept = item;

      for (let i = this.navigationBarList.length - 1; i > index; i--) {
        this.calculateSelectStatus(this.navigationBarList[i]);
        this.easyCalculateSum(this.navigationBarList[i]);
      }

      //删除导航栏后面的值
      this.removeNavBar(index);
    },
    //班组导航栏显示
    groupNavBarClick(item, index) {
      console.log('group ', item);
      item.isAllCheck = false;
      if (index === 0) {
        this.groupShow = true;
        this.groupNavigationBarList.splice(index + 1, this.groupNavigationBarList.length - index);

        this.currentObjectGroup = item;
        console.log('班组所有的信息集合', this.currentObjectGroup);
      } else {
        return;
      }
    },
    //删除导航栏后面的值
    removeNavBar(index) {
      this.navigationBarList.splice(index + 1, this.navigationBarList.length - index);
    },
    //推入导航栏
    pushNavBar(obj, data) {
      data.push(obj);
    },
    //给部门增加一些字段
    addField(data) {
      data.forEach((item) => {
        this.$set(item, 'isChecked', false);
        this.$set(item, 'checkSum', 0);
        this.$set(item, 'isAllCheck', false);
        this.$set(item, 'halfCheck', false);
        if (item.children && item.children.length > 0) {
          item.children.forEach((childrenItem) => {
            childrenItem.parent = item;
          });
          this.addField(item.children);
        }
      });
      console.log('加载字段后的数据集', data);
    },

    //加载部门
    async getDeptTree() {
      console.log('*******111111----',this.option)
      if (this.option.deptId) {
        await getDeptUserListByDeptId({ projectId: this.option.projectId, deptId: this.option.deptId }).then(
          (res) => {
            this.deptData 
           let arry = res.data;
          arry.forEach((item) => {
            this.$set(item, 'isChecked', false);
            this.selectPeopleList.forEach((item1) => {
              if (item1.id == item.id) {
                console.log('已有');
                item.isChecked = true;
              }
            });
            item.parent = this.deptData;
          });
          let peopleObj = {
            peopleList: arry,
            parent: this.deptData,
          };
          this.$set(this.deptData, 'peopleListInfo', peopleObj);
            // this.getPeople(this.deptData);
            console.log('加载的部门列表', this.deptData);
            this.currentObjectDept = this.deptData;
            console.log('加载的部门列表++++', this.currentObjectDept);
         
          }
        );
      } 
    },
    //加载班组
    getGroupTree() {
      getGroupList({ projectId: this.option.projectId }).then((res) => {
        this.groupList = res.data;

        this.groupList.forEach((item) => {
          this.$set(item, 'isChecked', false);
          this.$set(item, 'isAllCheck', false);
        });

        this.addField(this.groupList);
        let obj = {
          title: this.deptData.title,
          id: this.deptData.id,
          children: this.groupList,
        };
        this.pushNavBar(obj, this.groupNavigationBarList);
        console.log('this.groupNavigationBarList', this.groupNavigationBarList);
        this.currentObjectGroup = obj;
      });
    },
    //根据部门查人员
    async getPeople(dept) {
      if (dept.peopleListInfo && dept.peopleListInfo.peopleList.length > 0) {
        return;
      }
      await getUserListByDepartmentId({
        deptId: dept.id,
        projectId: this.option.projectId,
      }).then((res) => {
        let arry = res.data;
        arry.forEach((item) => {
          this.$set(item, 'isChecked', false);
          this.selectPeopleList.forEach((item1) => {
            if (item1.id == item.id) {
              console.log('已有');
              item.isChecked = true;
            }
          });
          item.parent = dept;
        });
        let peopleObj = {
          peopleList: arry,
          parent: dept,
        };
        this.$set(dept, 'peopleListInfo', peopleObj);
      });
    },
    //根据班组查人员
    async getPeopleByGroup(group) {
      console.log('班组集合ddd', this.groupList);
      if (group.peopleListInfo && group.peopleListInfo.peopleList.length > 0) {
        return;
      }
      await getMenberUserList({ groupId: group.id }).then((res) => {
        let arry = res.data;
        arry.forEach((item) => {
          this.$set(item, 'isChecked', false);
          item.parent = group;
        });
        let peopleObj = {
          peopleList: arry,
          parent: group,
        };
        this.$set(group, 'peopleListInfo', peopleObj);
      });
    },
    //点击部门复选框
    clickCheckBox(value, data) {
      console.log('???888?', value);
      if (!value.isChecked) {
        console.log('ok');
        value.halfCheck = false;
        value.checkSum = 0;
        this.setDeptStatus(value, false);
        this.removeItemFormData(value, data);
      } else {
        console.log('false');
        if (this.option.prohibitList.length > 0) {
          for (let i = 0; i < this.option.prohibitList.length; i++) {
            if (this.option.prohibitList[i].id == value.id) {
              value.isChecked = false;
              this.$message({
                message: '禁止选择该部门',
                type: 'warning',
              });
              return;
            }
          }
        }
        if (this.choiceModel == 'dept') {
          if (data.length == this.option.limit) {
            value.isChecked = false;
            this.$message({
              message: '选择部门已达上限',
              type: 'warning',
            });
            return;
          }
        }
        value.halfCheck = false;
        this.removeDeptAllitem(value);
        // this.calculateSelectDeptSum(value.parent,value.userSum,'add')//父级计算
        value.checkSum = value.userSum;
        this.insertItemToData(value, data);
        this.setDeptStatus(value, true);
      }

      console.log('???888?', value);
      console.log('这是所有数据集合', this.deptData);
      // console.log('这是所有bumen数据集合', this.selectDeptList);
      this.$forceUpdate();
      this.calculatePeopleSum();
    },
    //选中部门，部门下面的所有子部门都变成相同状态
    setDeptStatus(dept, flag) {
      console.log('变成相同状态', flag);
      if (dept.peopleListInfo && dept.peopleListInfo.peopleList.length > 0) {
        dept.peopleListInfo.peopleList.forEach((peo1) => {
          peo1.isChecked = flag;
        });
      }
      if (dept.hasChildren) {
        dept.children.forEach((item) => {
          item.isChecked = flag;
          if (item.peopleListInfo && item.peopleListInfo.peopleList.length > 0) {
            item.peopleListInfo.peopleList.forEach((peo) => {
              peo.isChecked = flag;
            });
          }
          if (item.hasChildren) {
            this.setDeptStatus(item, flag);
          }
        });
      }
    },
    calculateSingleSelectSum(obj, num) {
      if (obj) {
        obj.checkSum = num;
        if (num == -1) {
          console.log('等于-1');
        }
        console.log('部门', obj.title, obj.checkSum, obj.parent);
        if (obj.parent) {
          this.calculateSingleSelectSum(obj.parent, num);
        } else {
          console.log('没有上级的单选：');
          console.log('没有上级的单选：', obj.realName || obj.title);
        }
      }
    },
    calculateSelectDeptSum(obj, num, type) {
      if (obj) {
        if (type == 'add') {
          console.log('部门', obj.title, obj.checkSum);
          obj.checkSum += num;
          if (obj.parent) {
            this.calculateSelectDeptSum(obj.parent, num, type);
          }
        } else {
          obj.checkSum -= num;
          if (obj.parent) {
            this.calculateSelectDeptSum(obj.parent, num, type);
          }
        }
      }
    },
    calculateSelectSum(obj, type) {
      if (type == 'add') {
        obj.checkSum++;
        if (obj.parent) {
          this.calculateSelectSum(obj.parent, type);
        }
      } else {
        obj.checkSum--;
        if (obj.parent) {
          this.calculateSelectSum(obj.parent, type);
        }
      }
    },

    //单选模式操作已选的
    singleModelOperatorSelect(item, selectList) {
      selectList.forEach((item_) => {
        item_.isChecked = false;
        this.calculateSingleSelectSum(item_.parent, 0);
      });
      item.isChecked = true;
      selectList.splice(0, selectList.length);
      selectList.push(item);

      console.log('单选模式的结果selectList', selectList);
      console.log('单选模式的结果selectPeopleList', this.selectPeopleList);
    },
    //点击人员复选框
    clickPeopleCheckBox(value, data, peopleInfo) {
      let parent = peopleInfo.parent;
      //禁止选择人员

      console.log('???888?', value);
      if (!value.isChecked) {
        this.removeItemFormData(value, data);
        this.deletGroup(value);

        //  this.calculateSelectSum(parent,"reduce")
        //  this.$set(value,'isChecked',true)
      } else {
        if (this.option.prohibitList.length > 0) {
          for (let i = 0; i < this.option.prohibitList.length; i++) {
            if (this.option.prohibitList[i].id == value.id) {
              value.isChecked = false;
              this.$message({
                message: '禁止选择该人员',
                type: 'warning',
              });
              return;
            }
          }
        }
        if (this.choiceModel == 'people') {
          if (data.length == this.option.limit) {
            value.isChecked = false;
            this.$message({
              message: '选择人数已达上限',
              type: 'warning',
            });
            return;
          }
        }
        console.log('模式', this.choiceModel);
        if (this.choiceModel == 'singlePeople') {
          this.singleModelOperatorSelect(value, this.selectPeopleList);
          this.calculateSingleSelectSum(value.parent, 1);
        } else {
          this.insertItemToData(value, data);
          this.calculateSelectSum(parent, 'add');
        }

        //  this.$set(value,'isChecked',false)
      }
      if (value.name) {
        //代表的是班组
        this.calculateGroupSelectStatus(parent);
        // this.calculateSingleSelectSum(parent,1)
      } else {
        this.calculateSelectStatus(parent);
      }
      this.$forceUpdate();
      this.calculatePeopleSum();
      try {
        let arry = this.currentObjectDept.peopleListInfo.peopleList;
        let arry2 = this.selectPeopleList;
        for (let i = 0; i < arry.length; i++) {
          for (let j = 0; j < arry2.length; j++) {
            if (arry[i].id == arry2[j].id) {
              arry[i].isChecked = true;
              break;
            } else {
              arry[i].isChecked = false;
            }
          }
        }
      } catch {
        console.log('这是所有数据集合', this.deptData);
      }
      console.log('这是所有数据集合', this.deptData);
      console.log('----', value.isChecked);
      console.log('班组所有的信息集合', this.groupList);
    },
    //点击人员复选框
    clickGroupPeopleCheckBox(value, data, peopleInfo) {
      let parent = peopleInfo.parent;
      //禁止选择人员

      console.log('???888?', value);
      if (!value.isChecked) {
        this.removeItemFormData(value, data);
        this.deptOperatePeopleStatus(this.deptData, value.id);

        //  this.calculateSelectSum(parent,"reduce")
        //  this.$set(value,'isChecked',true)
      } else {
        if (this.option.prohibitList.length > 0) {
          for (let i = 0; i < this.option.prohibitList.length; i++) {
            if (this.option.prohibitList[i].id == value.id) {
              value.isChecked = false;
              this.$message({
                message: '禁止选择该人员',
                type: 'warning',
              });
              return;
            }
          }
        }
        if (this.choiceModel == 'people') {
          if (data.length == this.option.limit) {
            value.isChecked = false;
            this.$message({
              message: '选择人数已达上限',
              type: 'warning',
            });
            return;
          }
        }
        console.log('模式', this.choiceModel);
        if (this.choiceModel == 'singlePeople') {
          this.singleModelOperatorSelect(value, this.selectPeopleList);
          this.calculateSingleSelectSum(value.parent, 1);
        } else {
          this.insertItemToData(value, data);
          this.calculateSelectSum(parent, 'add');
        }

        //  this.$set(value,'isChecked',false)
      }
      if (value.name) {
        //代表的是班组
        this.calculateGroupSelectStatus(parent);
        // this.calculateSingleSelectSum(parent,1)
      } else {
        this.calculateSelectStatus(parent);
      }
      this.currentObjectDept.peopleListInfo.peopleList.forEach((item) => {
        this.selectPeopleList.forEach((item1) => {
          if (item1.id == item.id) {
            console.log('已有');
            item.isChecked = true;
          }
        });
      });
      this.$forceUpdate();
      this.calculatePeopleSum();
      console.log('这是所有数据集合', this.deptData);
      console.log('----', value.isChecked);
      console.log('班组所有的信息集合', this.groupList);
    },
    //点击搜索人员复选框
    clickSearchPeopleCheckBox(value, data) {
      if (!value.isChecked) {
        this.removeItemFormData(value, data);
        this.deptOperatePeopleStatus(this.deptData, value.id);
        //  this.$set(value,'isChecked',true)
      } else {
        if (this.option.prohibitList.length > 0) {
          for (let i = 0; i < this.option.prohibitList.length; i++) {
            if (this.option.prohibitList[i].id == value.id) {
              value.isChecked = false;
              this.$message({
                message: '禁止选择该人员',
                type: 'warning',
              });
              return;
            }
          }
        }
        if (this.choiceModel == 'people') {
          if (data.length == this.option.limit) {
            value.isChecked = false;
            this.$message({
              message: '选择人数已达上限',
              type: 'warning',
            });
            return;
          }
        }

        console.log('模式', this.choiceModel);
        if (this.choiceModel == 'singlePeople') {
          this.singleModelOperatorSelect(value, this.selectPeopleList);
        } else {
          this.insertItemToData(value, data);
        }
      }
      this.calculatePeopleSum();
      let arry = this.currentObjectDept.peopleListInfo.peopleList;
      let arry2 = this.selectPeopleList;
      for (let i = 0; i < arry.length; i++) {
        for (let j = 0; j < arry2.length; j++) {
          if (arry[i].id == arry2[j].id) {
            arry[i].isChecked = true;
            break;
          } else {
            arry[i].isChecked = false;
          }
        }
      }

      // this.currentObjectDept.peopleListInfo.peopleList.forEach(item=>{
      //   this.selectPeopleList.forEach(item1=>{
      //     if(item1.id==item.id){
      //       console.log('已有')
      //       item.isChecked = true
      //     }else{
      //       item.isChecked = false
      //     }
      //   })
      // })
    },
    //选择部门后将部门下面的说有人员和子部门全部删除
    removeDeptAllitem(dept) {
      //第一步删除人员
      if (dept.userSum > 0 && dept.peopleListInfo && dept.peopleListInfo.peopleList.length > 0) {
        dept.peopleListInfo.peopleList.forEach((item) => {
          let deleteNum = -1;
          this.selectPeopleList.forEach((selectItem, index) => {
            if (selectItem.id == item.id) {
              deleteNum = index;
            }
          });
          if (deleteNum >= 0) {
            this.selectPeopleList.splice(deleteNum, 1);
          }
        });
      }
      //删除部门
      if (dept.hasChildren) {
        dept.children.forEach((item) => {
          let deleteNum = -1;
          this.selectDeptList.forEach((selectItem, index) => {
            if (item.id == selectItem.id) {
              deleteNum = index;
            }
          });
          if (deleteNum >= 0) {
            this.selectDeptList.splice(deleteNum, 1);
          }
          this.removeDeptAllitem(item);
        });
      }
    },
    //点击班组复选框
    clickGroupCheckBox(value, data) {
      console.log('???888?', value.isChecked);

      value.halfCheck = false;

      if (!value.isChecked) {
        value.checkSum = 0;

        this.removeItemFormData(value, data);
      } else {
        value.checkSum = value.userSum;
        this.removeDeptAllitem(value);
        this.insertItemToData(value, data);
      }
      // console.log('这是所有bumen数据集合', this.selectDeptList);
      this.$forceUpdate();
      this.calculatePeopleSum();
      console.log('班组所有的信息集合', this.groupList);
    },
    //计算全选和半选
    calculateSelectStatus(item) {
      item.isChecked = false;
      item.isAllCheck = false;
      item.halfCheck = false;
      console.log(item.title);
      let childrenCheckFlag = false;
      let childrenCheckHalfFlag = false;
      if (item.hasChildren) {
        let checkedDeptNum = 0;
        item.children.forEach((deptItem) => {
          if (deptItem.isChecked) {
            checkedDeptNum++;
          }
          if (deptItem.halfCheck) {
            item.halfCheck = true;
          }
        });
        if (checkedDeptNum == item.children.length) {
          childrenCheckFlag = true;
        } else {
          if (checkedDeptNum > 0 && checkedDeptNum < item.children.length) {
            childrenCheckHalfFlag = true;
          }
        }
      } else {
        childrenCheckFlag = true;
      }
      let peopleCheckFlag = false;
      let peopleCheckHalfFlag = false;
      if (item.peopleListInfo && item.peopleListInfo.peopleList.length >= 0) {
        let peopleCheckNum = 0;
        item.peopleListInfo.peopleList.forEach((peopleItem) => {
          if (peopleItem.isChecked) {
            peopleCheckNum++;
          }
        });
        if (peopleCheckNum == item.peopleListInfo.peopleList.length) {
          peopleCheckFlag = true;
        } else {
          if (peopleCheckNum > 0 && peopleCheckNum < item.peopleListInfo.peopleList.length) {
            peopleCheckHalfFlag = true;
          }
        }
      }
      console.log('部门', item);
      console.log('部门的子部门', childrenCheckFlag);
      console.log('部门的人员', peopleCheckFlag);
      //判断该部门是否全选
      if (peopleCheckFlag && childrenCheckFlag) {
        item.isChecked = true;
        item.checkSum = item.userSum;
        item.isAllCheck = true;
        item.halfCheck = false;
      } else {
        item.isChecked = false;
        item.isAllCheck = false;
        if (peopleCheckFlag || childrenCheckFlag) {
          if (
            item.hasChildren &&
            item.peopleListInfo &&
            item.peopleListInfo.peopleList.length > 0
          ) {
            console.log(item.peopleListInfo);
            console.log('部门的全选', childrenCheckFlag);
            console.log('人员的全选', peopleCheckFlag);
            item.halfCheck = true;
          }
        }
        if (peopleCheckHalfFlag || childrenCheckHalfFlag) {
          console.log('部门的', childrenCheckHalfFlag);
          console.log('人员的', peopleCheckHalfFlag);
          item.halfCheck = true;
        }
      }
      //  if(!(item.hasChildren&&item.peopleListInfo&&item.peopleListInfo.peopleList.length>0)){
      //       item.isChecked =false
      //       item.halfCheck =false
      //       item.isAllCheck= false
      //     }
      if (!item.hasChildren && item.peopleListInfo && item.peopleListInfo.peopleList.length == 0) {
        item.isChecked = false;
        item.halfCheck = false;
        item.isAllCheck = false;
      }
      console.log('部门jiegou', item);
    },
    //计算班组下的全选和半选
    calculateGroupSelectStatus(item) {
      let childrenCheckFlag = true;
      let peopleCheckFlag = true;
      let halfCheck = false;

      if (item.peopleListInfo && item.peopleListInfo.peopleList.length > 0) {
        let num = 0;
        item.peopleListInfo.peopleList.forEach((peopleItem) => {
          if (!peopleItem.isChecked) {
            peopleCheckFlag = false;
          } else {
            num++;
          }
        });
        if (num > 0 && num < item.peopleListInfo.peopleList.length) {
          halfCheck = true;
        }
      } else {
        peopleCheckFlag = true;
      }
      if (childrenCheckFlag && peopleCheckFlag) {
        this.$set(item, 'isAllCheck', true);
        this.$set(item, 'isChecked', true);
      } else {
        this.$set(item, 'halfCheck', halfCheck);
      }
      if (item.parent) {
        this.calculateGroupSelectStatus(item.parent);
      }
    },
    //点击下级
    goSubordinate(obj) {
      // if (obj.isChecked) {
      //   return;
      // }
      obj.isAllCheck = false;
      //给所有子级加上parent指向
      if (obj.children && obj.children.length > 0) {
        obj.children.forEach((item) => {
          this.$set(item, 'parent', obj);
        });
      }

      this.pushNavBar(obj, this.navigationBarList);
      this.nowDeptList = obj.children;
      this.getPeople(obj);
      this.currentObjectDept = obj;
      try {
        this.currentObjectDept.peopleListInfo.peopleList.forEach((item) => {
          this.selectPeopleList.forEach((item1) => {
            if (item1.id == item.id) {
              console.log('已有');
              item.isChecked = true;
            }
          });
        });
      } catch {
        console.log('这是所有数据集合', this.deptData);
      }
    },
    //班组下级
    async goGroupSubordinate(obj) {
      if (obj.isChecked) {
        return;
      }
      obj.isAllCheck = false;
      await this.getPeopleByGroup(obj);
      this.currentObjectGroup = obj;
      //已选的勾上

      try {
        this.currentObjectGroup.peopleListInfo.peopleList.forEach((item) => {
          this.selectPeopleList.forEach((item1) => {
            if (item1.id == item.id) {
              console.log('已有');
              item.isChecked = true;
            }
          });
        });
      } catch {
        console.log('这是所有数据集合', this.deptData);
      }
      this.pushNavBar(obj, this.groupNavigationBarList);
      this.groupShow = false;
      console.log('班组集合', this.currentObjectGroup);
    },

    //数组插入元素（去重）全选
    insertItemToData(item, targetArry) {
      let flag = false;
      let itemIndex = -1;
      item.isChecked = true;
      targetArry.forEach((item_, index) => {
        if (item.id == item_.id) {
          itemIndex = index;
          item_.isChecked = false;
        }
      });
      if (itemIndex >= 0) {
        if (targetArry[itemIndex].parent) {
          // this.calculateSelectSum(targetArry[itemIndex].parent,"reduce")
        }

        targetArry.splice(itemIndex, 1);
      }
      targetArry.push(item);
      targetArry[targetArry.length - 1].isChecked = true;
    },
    //将一个集合插入到另一个集合 全选 targetArry:已选的集合
    mergeArry(arry, targetArry) {
      console.log('合并员', arry);
      if (arry && arry.length > 0) {
        arry.forEach((item) => {
          item.isChecked = true;
          item.checkSum = item.userSum || 0;
          item.halfCheck = false;
          this.insertItemToData(item, targetArry);
        });
      }
    },
    //已选择的集合移除选中 item ：树形集合中的元素
    removeItemFormData(item, data) {
      console.log('调用了移除', item);

      let itemIndex;
      if (item.peopleListInfo && item.peopleListInfo.peopleList.length > 0) {
        console.log('深度移除所有的人员', item.peopleListInfo.peopleList);
        this.removeArry(item.peopleListInfo.peopleList, this.selectPeopleList);
      }
      data.forEach((item_, index) => {
        if (item.id == item_.id) {
          itemIndex = index;
          item_.isChecked = false;
        }
      });
      if (itemIndex >= 0) {
        console.log('bbb', data[itemIndex]);

        data.splice(itemIndex, 1);
      }

      if (item.hasChildren) {
        //深度移除所有的部门和人员
        console.log('存在子级:', item.title, item.children.peopleListInfo);
        this.removeArry(item.children, data);
      }
      this.calculatePeopleSum();
    },
    removeArry(arry, targetArry) {
      if (arry.length > 0) {
        arry.forEach((item) => {
          item.isAllCheck = false;
          item.halfCheck = false;
          item.checkSum = 0;
          item.isChecked = false; //取消选中
          this.removeItemFormData(item, targetArry);
        });
      }
    },
    easyCalculateSum(dept) {
      console.log('jisuanqq', dept);
      dept.checkSum = 0;
      if (dept.hasChildren) {
        dept.children.forEach((item) => {
          dept.checkSum += item.checkSum;
        });
      }
      if (dept.peopleListInfo && dept.peopleListInfo.peopleList.length > 0) {
        dept.peopleListInfo.peopleList.forEach((peo) => {
          if (peo.isChecked) {
            dept.checkSum++;
          }
        });
      }
      console.log('jisuanhou', dept);
    },
    // 全选
    handleCheckAllChange() {
      this.currentObjectDept.halfCheck = false;

      if (this.currentObjectDept.isAllCheck) {
        console.log('yes');
        this.currentObjectDept.checkSum = this.currentObjectDept.userSum;

        this.currentObjectDept.isChecked = true;
        // this.setDeptStatus(this.currentObjectDept,this.currentObjectDept.isAllCheck)
        //将当前部门所有人员和下属部门进行插入到已选择的集合中

        if (this.currentObjectDept.hasChildren) {
          this.mergeArry(this.currentObjectDept.children, this.selectDeptList);
          this.currentObjectDept.children.forEach((item) => {
            //删除子部门
            this.removeDeptAllitem(item);
          });
        }

        if (this.choiceModel == 'unlimitPeople') {
          if (this.currentObjectDept.peopleListInfo) {
            this.mergeArry(this.currentObjectDept.peopleListInfo.peopleList, this.selectPeopleList);
          }
        }
        this.removeProhibit();
      } else {
        console.log('no');
        this.currentObjectDept.checkSum = 0;
        this.currentObjectDept.isChecked = false;
        this.currentObjectDept.checkSum = 0;

        if (this.currentObjectDept.children) {
          this.removeArry(this.currentObjectDept.children, this.selectDeptList);
        }

        this.removeArry(this.currentObjectDept.peopleListInfo.peopleList, this.selectPeopleList);
      }
      // this.calculateSelectStatus(this.currentObjectDept)
      this.calculatePeopleSum();
    },
    //全选删除禁止选择的人
    removeProhibit() {
      let data;
      if (
        this.choiceModel == 'dept' ||
        this.choiceModel == 'singleDept' ||
        this.choiceModel == 'unlimitDept'
      ) {
        data = this.selectDeptList;
      } else {
        data = this.selectPeopleList;
      }

      if (this.option.prohibitList.length > 0) {
        for (let i = 0; i < this.option.prohibitList.length; i++) {
          let removeIndex = -1;
          data.forEach((item, index) => {
            if (item.id == this.option.prohibitList[i].id) {
              item.isChecked = false;
              removeIndex = index;
            }
          });
          if (removeIndex >= 0) {
            data.splice(removeIndex, 1);
          }
        }
        this.$message('已过滤');
      }
    },
    //全选计算数量（只用计算当前部门层级下面的数据其余不需要关心）
    calculateAllSelectSum(dept) {
      if (dept.children) {
        dept.children.forEach((item) => {
          item.checkSum = item.userSum;
          item.halfCheck = false;
        });
      }
    },
    handleGroupCheckAllChange() {
      console.log('this.currentObjectGroup', this.currentObjectGroup);
      this.currentObjectGroup.halfCheck = false;
      if (this.currentObjectGroup.isAllCheck) {
        //将当前部门所有人员和下属部门进行插入到已选择的集合中
        this.handleSelectAllGroupOk(this.currentObjectGroup);
        this.calculateAllSelectSum(this.currentObjectGroup);
        if (this.currentObjectGroup.children) {
          this.mergeArry(this.currentObjectGroup.children, this.selectGroupList);
        }
        if (this.choiceModel == 'unlimitPeople') {
          if (this.currentObjectGroup.peopleListInfo) {
            this.mergeArry(
              this.currentObjectGroup.peopleListInfo.peopleList,
              this.selectPeopleList
            );
          }
        }
        this.removeProhibit();
      } else {
        this.handleSelectAllGroupFalse(this.currentObjectGroup);
        if (this.currentObjectGroup.children) {
          console.log('22222');
          this.removeArry(this.currentObjectGroup.children, this.selectGroupList);
        }

        if (this.currentObjectGroup.peopleListInfo) {
          this.removeArry(this.currentObjectGroup.peopleListInfo.peopleList, this.selectPeopleList);
        }
      }
      this.calculatePeopleSum();
    },
    handleSelectAllGroupOk(value) {
      value.checkSum = value.userSum;
      value.isChecked = true;
      value.halfCheck = false;
      if (value.peopleListInfo) {
        value.peopleListInfo.peopleList.forEach((item) => {
          item.isChecked = true;
        });
      }
    },
    handleSelectAllGroupFalse(value) {
      value.isChecked = false;
      value.checkSum = 0;
      value.halfCheck = false;
      if (value.peopleListInfo) {
        value.peopleListInfo.peopleList.forEach((item) => {
          item.isChecked = false;
        });
      }
    },
    submitSelect() {
      let deptIdList = [];
      let userIdList = [];
      let removeUserIdList = [];
      let groupIdList = [];
      this.selectDeptList.forEach((item) => {
        this.getAllDeptId(item, deptIdList);
      });
      this.selectPeopleList.forEach((people) => {
        userIdList.push(people.id);
      });
      this.option.prohibitList.forEach((prohibit) => {
        removeUserIdList.push(prohibit.id);
      });
      this.selectGroupList.forEach((group) => {
        groupIdList.push(group.id);
      });
      getAssembleUser({
        deptIdList,
        userIdList,
        removeUserIdList,
        groupIdList,
      }).then((res) => {
        this.submitList = res.data;
        this.$emit('getSelectList', this.submitList);
        this.$emit('update:visible', false);
      });
      console.log('所有部门id', deptIdList);
    },
    //递归遍历拿到所有的部门id
    getAllDeptId(node, data) {
      data.push(node.id);
      if (node.children && node.children.length > 0) {
        node.children.forEach((item) => {
          this.getAllDeptId(item, data);
        });
      } else {
        return;
      }
    },
  },
};
</script>
<style>
#choicePeopleComponent .el-checkbox {
  margin-right: 8px !important;
}
#popover20220215 {
}
</style>

<style lang="scss" scoped>
::v-deep .el-popper {
  width: 22%;
}
.subordinateLable {
  margin-right: 24px;
  color: #409eff;
}
.dept {
  height: 466px;
  overflow: scroll;
}
.team {
  height: 466px;
  overflow: scroll;
}
.selectInfo {
  height: 440px;
  overflow: scroll;
  width: 100%;
  padding: 0 12px;
  .selectItem {
    float: left;
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
.navigation_bar {
  display: flex;
  flex-wrap: wrap;
}
.el-checkbox-group {
  display: grid;
  grid-template-rows: 1fr;
  grid-row-gap: 16px;
  .choice_item {
    display: flex;
    justify-content: space-between;
  }
}
::v-deep .el-checkbox__label {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px !important;
}
.searchResult {
  max-height: 336px;
  width: 100%;
  overflow: scroll;
  .searchChoice_item {
  }
}
::v-deep .search-color {
  color: #409eff;
  display: inline-block;
}
::v-deep .el-radio-button__inner {
  height: 35px;
  width: 100px;
}
</style>
